export const selectFactoryChannels = (state) => state.factoryChannels.channels;

export const selectFactoryChannelsLoading = (state) => state.factoryChannels.loading;
export const selectFactoryChannelsError = (state) => state.factoryChannels.error;